import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
import { formatShieldUrl } from './Rival';
export default class Match extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "teamId", Model.attribute('teamId'));
    _defineProperty(this, "competitionId", Model.attribute('competitionId'));
    _defineProperty(this, "seasonId", Model.attribute('seasonId'));
    _defineProperty(this, "seasonName", Model.attribute('seasonName'));
    _defineProperty(this, "opponent", Model.attribute('opponent'));
    _defineProperty(this, "discussionId", Model.attribute('discussionId'));
    _defineProperty(this, "preMatchDiscussionId", Model.attribute('preMatchDiscussionId'));
    _defineProperty(this, "bolillaDiscussionId", Model.attribute('bolillaDiscussionId'));
    _defineProperty(this, "matchDate", Model.attribute('matchDate', Model.transformDate));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "scoreAthletic", Model.attribute('scoreAthletic'));
    _defineProperty(this, "scoreOpponent", Model.attribute('scoreOpponent'));
    _defineProperty(this, "isKnockout", Model.attribute('isKnockout'));
    _defineProperty(this, "knockoutWinner", Model.attribute('knockoutWinner'));
    _defineProperty(this, "isLocal", Model.attribute('isLocal'));
    _defineProperty(this, "jornada", Model.attribute('jornada'));
    _defineProperty(this, "status", Model.attribute('status'));
    _defineProperty(this, "pressConferenceUrl", Model.attribute('pressConferenceUrl'));
    _defineProperty(this, "callupUrl", Model.attribute('callupUrl'));
    _defineProperty(this, "tvChannel", Model.attribute('tvChannel'));
    _defineProperty(this, "previewUrl", Model.attribute('previewUrl'));
    _defineProperty(this, "postPressConferenceUrl", Model.attribute('postPressConferenceUrl'));
    _defineProperty(this, "highlightsUrl", Model.attribute('highlightsUrl'));
    _defineProperty(this, "fullMatchUrl", Model.attribute('fullMatchUrl'));
    _defineProperty(this, "referee", Model.attribute('referee'));
    _defineProperty(this, "varReferee", Model.attribute('varReferee'));
    _defineProperty(this, "attendance", Model.attribute('attendance'));
    _defineProperty(this, "notesHtml", Model.attribute('notesHtml'));
    _defineProperty(this, "goalEvents", Model.attribute('goalEvents'));
    _defineProperty(this, "rival", Model.hasOne('rival'));
    _defineProperty(this, "competition", Model.hasOne('competition'));
    _defineProperty(this, "players", Model.hasMany('players'));
    _defineProperty(this, "votes", Model.hasMany('votes'));
    _defineProperty(this, "bolillaVotes", Model.hasMany('bolillaVotes'));
    _defineProperty(this, "userMatchLineups", Model.hasMany('userMatchLineups'));
    _defineProperty(this, "discussion", Model.hasOne('discussion'));
    _defineProperty(this, "preMatchDiscussion", Model.hasOne('preMatchDiscussion'));
    _defineProperty(this, "bolillaDiscussion", Model.hasOne('bolillaDiscussion'));
    _defineProperty(this, "season", Model.hasOne('season'));
    _defineProperty(this, "team", Model.hasOne('team'));
  }
  apiEndpoint() {
    return '/nagusi/match-ratings/matches' + (this.exists ? '/' + this.data.id : '');
  }
  isSuspended() {
    const s = this.status();
    return s === 'suspended_with_lineup' || s === 'suspended_without_lineup';
  }
  isSuspendedWithLineup() {
    return this.status() === 'suspended_with_lineup';
  }
  isSuspendedWithoutLineup() {
    return this.status() === 'suspended_without_lineup';
  }
  getName() {
    const jornada = this.jornada() ? this.jornada() + ' ' : '';
    const athletic = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic';
    // Use rival name if available, fallback to opponent attribute
    const rival = this.rival();
    const opponentName = rival ? rival.name() : this.opponent();
    const isLocal = !!this.isLocal();
    const score = this.getScore();
    const localName = isLocal ? athletic : opponentName;
    const visitorName = isLocal ? opponentName : athletic;
    if (this.isSuspended()) {
      return "".concat(jornada).concat(localName, " - ").concat(visitorName, " [SUSPENDIDO]");
    }
    if (score) {
      const _score$split = score.split(' - '),
        _score$split2 = _slicedToArray(_score$split, 2),
        scoreLocal = _score$split2[0],
        scoreVisitor = _score$split2[1];
      return "".concat(jornada).concat(localName, " ").concat(scoreLocal, " - ").concat(scoreVisitor, " ").concat(visitorName);
    }
    return "".concat(jornada).concat(localName, " - ").concat(visitorName);
  }
  getScore() {
    if (this.scoreAthletic() === null || this.scoreOpponent() === null) return null;
    const isLocal = !!this.isLocal();
    const local = this.scoreAthletic();
    const visitor = this.scoreOpponent();
    return isLocal ? "".concat(local, " - ").concat(visitor) : "".concat(visitor, " - ").concat(local);
  }
  getWinnerName() {
    const winner = this.knockoutWinner();
    if (!winner) return null;
    const rival = this.rival();
    const teamName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic';
    return winner === 'Athletic' ? teamName : rival ? rival.name() : this.opponent();
  }
  getOutcome() {
    const scoreAthletic = this.scoreAthletic();
    const scoreOpponent = this.scoreOpponent();
    if (scoreAthletic === null || scoreAthletic === undefined || scoreOpponent === null || scoreOpponent === undefined) {
      return null;
    }
    const scoreA = Number(scoreAthletic);
    const scoreO = Number(scoreOpponent);
    if (isNaN(scoreA) || isNaN(scoreO)) {
      return null;
    }
    if (scoreA > scoreO) {
      return 'win';
    }
    if (scoreA < scoreO) {
      return 'loss';
    }
    if (typeof this.isKnockout === 'function' && this.isKnockout()) {
      const winner = typeof this.knockoutWinner === 'function' ? this.knockoutWinner() : null;
      if (winner === 'Athletic') {
        return 'win';
      } else if (winner) {
        return 'loss';
      }
    }
    return 'draw';
  }
  getOutcomeBadgeStyle() {
    const outcome = this.getOutcome();
    if (outcome === 'win') {
      return {
        background: 'rgba(16, 185, 129, 0.15)',
        color: '#10b981',
        border: '1px solid rgba(16, 185, 129, 0.35)'
      };
    }
    if (outcome === 'loss') {
      return {
        background: 'rgba(238, 37, 35, 0.15)',
        color: '#ee2524',
        border: '1px solid rgba(238, 37, 35, 0.35)'
      };
    }
    if (outcome === 'draw') {
      return {
        background: 'rgba(148, 163, 184, 0.15)',
        color: '#94a3b8',
        border: '1px solid rgba(148, 163, 184, 0.3)'
      };
    }
    return {
      background: 'rgba(255, 255, 255, 0.08)',
      color: 'inherit',
      border: '1px solid rgba(255, 255, 255, 0.1)'
    };
  }
  renderName(options) {
    if (options === void 0) {
      options = {
        showJornada: true,
        showScore: true
      };
    }
    const showJornada = options && options.showJornada !== undefined ? options.showJornada : true;
    const showScore = options && options.showScore !== undefined ? options.showScore : true;
    const athletic = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic';
    const rival = this.rival();
    const opponentName = rival ? rival.name() : this.opponent() || '';
    const isLocal = !!this.isLocal();
    const score = showScore ? this.getScore() : null;
    const comp = typeof this.competition === 'function' ? this.competition() : null;
    let showJornadaText = showJornada && !!this.jornada();
    if (comp && showJornadaText) {
      const jLower = this.jornada().toLowerCase().trim();
      const compName = (typeof comp.name === 'function' ? comp.name() : '') || '';
      const compShort = (typeof comp.shortName === 'function' ? comp.shortName() : '') || '';
      const compSlug = (typeof comp.slug === 'function' ? comp.slug() : '') || '';
      if (compShort && jLower === compShort.toLowerCase().trim() || compName && jLower === compName.toLowerCase().trim() || compSlug && (jLower === compSlug.toLowerCase().trim() || compSlug === 'euskal-herriko-kopa' && (jLower === 'eh kopa' || jLower === 'ehk'))) {
        showJornadaText = false;
      }
    }
    const jornada = showJornadaText ? this.jornada() + ': ' : '';
    const outcomeStyle = this.getOutcomeBadgeStyle();

    // Get shields
    const athleticTeam = this.team();
    const defaultClubShield = athletic.includes('Real Sociedad') ? '/assets/extensions/nagusi-match-ratings/escudos/real-sociedad.png' : '/assets/extensions/nagusi-match-ratings/escudos/athletic-club.png';
    const rawClubShield = athleticTeam && typeof athleticTeam.logoUrl === 'function' ? athleticTeam.logoUrl() : null;
    const athleticShield = formatShieldUrl(rawClubShield) || defaultClubShield;
    const rivalShield = rival && typeof rival.escudo === 'function' ? formatShieldUrl(rival.escudo()) : null;
    const localName = isLocal ? athletic : opponentName;
    const visitorName = isLocal ? opponentName : athletic;
    const localShield = isLocal ? athleticShield : rivalShield;
    const visitorShield = isLocal ? rivalShield : athleticShield;
    const compBadge = comp && showJornada ? m("span", {
      className: "MatchName-Competition",
      style: "background: ".concat(comp.color() || '#ee2524', "1a; color: ").concat(comp.color() || '#ee2524', "; font-size: 0.8em; padding: 2px 6px; border-radius: 4px; margin-right: 4px; border: 1px solid ").concat(comp.color() || '#ee2524', "33; display: inline-flex; align-items: center; gap: 4px; vertical-align: middle;")
    }, comp.iconUrl && comp.iconUrl() && m("img", {
      src: comp.iconUrl(),
      alt: "",
      style: "width: 12px; height: 12px; object-fit: contain;"
    }), m("span", null, comp.shortName ? comp.shortName() : comp.name ? comp.name() : '')) : null;
    return m("span", {
      className: "MatchName-WithShields",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; flex-wrap: wrap; vertical-align: middle;"
    }, compBadge, jornada && m("span", {
      className: "MatchName-Jornada",
      style: "color: var(--muted-color); font-size: 0.9em; margin-right: 4px;"
    }, jornada), m("span", {
      className: "MatchName-Team local",
      style: "display: inline-flex; align-items: center; gap: 6px; vertical-align: middle;"
    }, localShield && m("img", {
      src: localShield,
      alt: "",
      style: "width: 22px; height: 22px; object-fit: contain; vertical-align: middle;"
    }), m("span", null, localName)), this.isSuspended() ? m("span", {
      className: "MatchName-Suspended",
      style: {
        background: 'rgba(245, 158, 11, 0.15)',
        color: '#f59e0b',
        border: '1px solid rgba(245, 158, 11, 0.35)',
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '0.85em',
        margin: '0 4px',
        display: 'inline-block',
        verticalAlign: 'middle',
        fontWeight: '700',
        letterSpacing: '0.5px'
      }
    }, "SUSPENDIDO") : score ? m("span", {
      className: "MatchName-Score",
      style: {
        background: outcomeStyle.background,
        color: outcomeStyle.color,
        border: outcomeStyle.border,
        padding: '2px 8px',
        borderRadius: '4px',
        fontFamily: 'monospace',
        fontSize: '1.05em',
        margin: '0 4px',
        display: 'inline-block',
        verticalAlign: 'middle',
        fontWeight: '800'
      }
    }, score) : m("span", {
      className: "MatchName-VS",
      style: "color: var(--muted-color); font-size: 0.85em; margin: 0 4px; vertical-align: middle;"
    }, "vs"), m("span", {
      className: "MatchName-Team visitor",
      style: "display: inline-flex; align-items: center; gap: 6px; vertical-align: middle;"
    }, m("span", null, visitorName), visitorShield && m("img", {
      src: visitorShield,
      alt: "",
      style: "width: 22px; height: 22px; object-fit: contain; vertical-align: middle;"
    })));
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/Match', Match);